import React, { useEffect, useRef, useState } from "react";
import { bool, node, number } from "prop-types";
import { classes } from "../utils/classes";
import { Col } from "../Grid";

const GuidePageTemplateSidebar = ({ isSticky = true, md = 4, children, ...props }) => {
	const ref = useRef();
	const [sticky, setSticky] = useState(false);
	useEffect(() => {
		if (ref && ref.current) {
			setSticky(isSticky && ref.current.clientHeight <= 720);
		}
	}, [ref, isSticky, setSticky]);
	return (
		<Col md={md} {...props}>
			<div
				ref={ref}
				className={classes(
					"guide-page-template__sidebar",
					sticky && "guide-page-template__sidebar--is-sticky",
				)}
			>
				{children}
			</div>
		</Col>
	);
};

GuidePageTemplateSidebar.propTypes = {
	isSticky: bool,
	children: node.isRequired,
	md: number,
};

export default GuidePageTemplateSidebar;
